import React from 'react';

type Props = {
  fill: string;
  fillPin?: string;
  opacity: string;
  className?: any;
};

const PinIcon = ({ fill, fillPin, opacity }: Props) => (
  <svg viewBox="0 0 30.77 30.75" xmlns="http://www.w3.org/2000/svg" height="100%">
    <circle cx="15.37" cy="15.32" r="15.13" style={{ fill: 'transparent' }} />
    <g style={{ opacity }}>
      <path
        d="M19.62,8.84,18.2,7.65s-.51-.49-.84-.45a1.77,1.77,0,0,0-.92.25c-.19.18-.5.34-.48.57s.17.78.19.93a5.78,5.78,0,0,1-.19.92L13.4,12.48a5.72,5.72,0,0,0-1.17,0c-.17.08-2.57.45-2.57.45l-.9.7-.29.76,2.4,2.9s-3.41,5.07-3.14,5,5-3.06,5-3.06,2.59,2.22,2.65,2.22a5.89,5.89,0,0,0,.84,0,6.83,6.83,0,0,0,.66-1.07l.76-3.72,3.08-3,.9.41L23,13.29v-.84Z"
        style={{ fill: fillPin }}
      />
      <path
        style={{ fill }}
        d="M20.82,14.3a1.24,1.24,0,0,0,1.76,0l.6-.6a1.24,1.24,0,0,0,0-1.76h0l-5-5a1.23,1.23,0,0,0-1.75,0l-.6.6a1.24,1.24,0,0,0,0,1.76l.05,0L13,12.27a6,6,0,0,0-4.5,1A1.25,1.25,0,0,0,8.21,15l.13.15,2.06,2.07L6.8,22.68a.47.47,0,0,0,.13.66.46.46,0,0,0,.52,0l5.43-3.6L15,21.81a1.22,1.22,0,0,0,.88.37h.1a1.26,1.26,0,0,0,.91-.51,6,6,0,0,0,1-4.51Zm-12,7L11.08,18l1.11,1.11ZM16.89,9l-.39-.39a.32.32,0,0,1,0-.43l.6-.6a.31.31,0,0,1,.42,0l5,5a.32.32,0,0,1,0,.43h0l-.6.6a.32.32,0,0,1-.43,0l-2.74-2.75a.48.48,0,0,0-.67,0,.49.49,0,0,0,0,.66l2,2L17,16.66a.45.45,0,0,0-.12.43,5.06,5.06,0,0,1-.83,4,.3.3,0,0,1-.43.06l0,0L13.27,18.8h0l-1.93-1.93L9,14.52a.33.33,0,0,1-.09-.23A.36.36,0,0,1,9,14.06a5.1,5.1,0,0,1,4-.82.51.51,0,0,0,.44-.13Z"
      />
      <path d="M12.87,14.08a4.19,4.19,0,0,0-2,.06.48.48,0,0,0,.13.93l.13,0A3.17,3.17,0,0,1,12.67,15a.47.47,0,0,0,.57-.34.48.48,0,0,0-.34-.58Z" />
    </g>
  </svg>
);

PinIcon.defaultProps = {
  fillPin: 'transparent',
  fill: '#d5d5d5',
  opacity: '1'
};

export default PinIcon;
